<template>
  <v-container fluid>
    <v-card style="margin-top: 20px">
      <v-card flat>
        <v-layout row style="margin-bottom: 16px;">
          <v-card flat>
            <v-card-text class="title">Payment Due College List</v-card-text>
          </v-card>
          <v-divider class="my-2" vertical></v-divider>
          <v-text-field
            v-model="search"
            prepend-inner-icon="search"
            label="Search"
            class="mt-0"
            hide-details
            solo
            flat
            type="number"
            single-line
          ></v-text-field>
          <v-spacer />
          <v-flex
            class="customeDateSearch text-xs-right"
            xs2
            style="margin-top: 5px; margin-bottom: 3px;"
          >
            <v-layout row justify-end>
              <v-dialog v-model="dialog" persistent max-width="600px">
                <template v-slot:activator="{ on }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on: tooltipOn }">
                      <v-btn
                        dark
                        color="primary"
                        v-on="{ ...on, ...tooltipOn }"
                      >
                        <v-icon dark>add</v-icon> Add New
                      </v-btn>
                    </template>
                    <span>Add New College to Block Admit Card</span>
                  </v-tooltip>
                </template>
                <v-card>
                  <v-card-title style="background-color: #3f51b5; color: #fff">
                    <span class="headline">Input College Codes</span>
                    <v-spacer></v-spacer>
                    <v-btn color="red" fab small dark @click="dialog = false"
                      ><v-icon>close</v-icon></v-btn
                    >
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          class="custom-multiline-text-field"
                          v-model="college_codes"
                          label="Enter College codes"
                          @input="formatInput"
                          :error-messages="errorMessage"
                          textarea
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <small style="color: red; font-size: 13px"
                      >EnterCollege Codes With
                      <strong>Comma (,)</strong> separated</small
                    >
                    <v-checkbox
                      style="margin-top: 40px;"
                      v-model="searchParam.delete_existing_data"
                      :true-value="1"
                      :false-value="0"
                      :label="
                        `Delete Existing Blocked Colleges Before Blocking New Colleges`
                      "
                    ></v-checkbox>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      v-if="showBot == 1 && college_codes != ''"
                      color="blue darken-1"
                      flat
                      @click="
                        $event.preventDefault();
                        $event.stopPropagation();
                        saveBlockedColleges();
                      "
                      >submits</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-btn
                style="color: #fff;"
                color="red"
                :disabled="!selected.length"
                @click="deleteSelectedColleges"
              >
                <v-icon left>delete</v-icon>
                Delete Selected ({{ selected.length }})
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- <v-data-table
          :headers="headers"
          :items="filteredColleges"
          :pagination.sync="pagination"
          :total-items="totalItems"
          :loading="loading"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.index + 1 }}</td>
            <td class="text-xs-left">
              {{ props.item.college_code }} - {{ props.item.college_name }}
            </td>
            <td class="text-xs-left">{{ props.item.added_by }}</td>

            <td class="text-xs-center">
              <v-btn
                color="red"
                style="color:#fff"
                fab
                small
                @click="deleteCollege(props.item.id)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template v-slot:no-data>
            <v-alert :value="true" color="error" icon="warning">
              Sorry, nothing to display here :(
            </v-alert>
          </template>
        </v-data-table> -->
        <h1 style="margin-bottom: -44px; margin-left: 48px; font-size: 19px; color: #fff;">All</h1>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="filteredColleges"
          :pagination.sync="pagination"
          :total-items="totalItems"
          :rows-per-page-items="[50, 100, 150, { text: 'All', value: -1 }]"
          :loading="loading"
          select-all
          show-select
          item-key="id"
          class="elevation-1"
        >

          <template v-slot:items="props">
            <tr :active="props.selected">
              <!-- checkbox -->
              <td style="width: 80px;">
                <v-checkbox
                  style="margin-left: -14px"
                  primary
                  hide-details
                  :input-value="props.selected"
                  @click.stop="props.selected = !props.selected"
                />
              </td>

              <td class="text-xs-center">{{ props.index + 1 }}</td>

              <td>
                {{ props.item.college_code }} - {{ props.item.college_name }}
              </td>

              <td>{{ props.item.added_by }}</td>

              <td class="text-xs-center">
                <v-btn
                  color="red"
                  fab
                  small
                  dark
                  @click="deleteCollege(props.item.id)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>

          <template v-slot:no-data>
            <v-alert :value="true" color="error" icon="warning">
              Sorry, nothing to display here :(
            </v-alert>
          </template>
        </v-data-table>
      </v-card>
    </v-card>
  </v-container>
</template>
<script>
import commonGet from "@/mixin/common_getters_mixin";
import commonExamYear from "../../mixin/exam_year_watch_mixin";
export default {
  mixins: [commonGet, commonExamYear],
  data() {
    return {
      selected: [],
      search: "",
      searchParam: {
        status: 1,
        exam_initiate_id: null,
        exam_year: null,
        id: null,
        delete_existing_data: 0,
      },
      headers: [
        {
          text: "SL",
          align: "center",
          value: "installment_no",
          sortable: false,
        },
        { text: "College Code & Name", value: "title", sortable: false },
        { text: "Added By", value: "start_date", sortable: false },
        { text: "Action", value: "", sortable: false },
      ],
      totalItems: 0,
      loading: false,
      pagination: {
        page: 1,
        rowsPerPage: 50,
      },
      dialog: false,
      number: "",
      college_codes: "",
      errorMessage: "",
      showBot: 1,
    };
  },
  created() {
    this.searchParam.exam_initiate_id = this.getExamInitiateId;
    this.searchParam.exam_year = this.getLoggedInYear.year;
    this.fetchPaymentDueCollegelist();
  },
  computed: {
    getBlockedCollegesData() {
      return this.$store.getters.getBlockedColleges;
    },
    filteredColleges() {
      if (!this.search) {
        return this.getBlockedCollegesData.data || [];
      }
      return this.getBlockedCollegesData.data.filter((item) =>
        String(item.college_code).includes(this.search),
      );
    },
  },
  watch: {
    pagination: {
      handler() {
        this.fetchPaymentDueCollegelist();
      },
      deep: true,
    },
  },
  methods: {
    fetchPaymentDueCollegelist() {
      let peram = {
        exam_code: this.getLoggedInExam.code,
        exam_year: this.getLoggedInYear.year,
        page: this.pagination.page,
        per_page: this.pagination.rowsPerPage,
      };
      console.log("This is Load Data", peram);
      this.loading = true;
      this.$store.dispatch("fetchBlockedCollegeData", peram).then((res) => {
        console.log("This is Load Data Response", res);
        this.loading = false;
        this.totalItems = res.total;
        this.pagination.rowsPerPage = res.per_page;
      });
    },
    formatInput() {
      if (/[A-Za-z]/.test(this.college_codes)) {
        this.errorMessage = "Only numbers are accepted";
        this.showBot = 0;
        return;
      } else {
        this.errorMessage = "";
        this.showBot = 1;
      }
      const plainNumber = this.college_codes.replace(/,/g, "");
      const formattedValue = plainNumber.replace(/(.{4})(?!$)/g, "$1,");
      this.college_codes = formattedValue;
      this.number = plainNumber;
    },
    saveBlockedColleges() {
      this.dialog = true;
      let blockParam = {
        exam_code: this.searchParam.exam_code,
        exam_year: this.searchParam.exam_year,
        college_codes: this.college_codes,
        delete_existing: this.searchParam.delete_existing_data,
      };
      console.log("Tanvir this is new blocked colleges data", blockParam);
      this.$store.dispatch("postBlockedCollegeData", blockParam).then(() => {
        this.loading = false;
        this.fetchPaymentDueCollegelist();
      });
    },

    deleteCollege(id) {
      console.log("Tanvir! This is delete ID:", id);

      if (!confirm("Are you sure you want to delete this college?")) {
        return;
      }
      this.$store
        .dispatch("deleteBlockedCollegeData", id)
        .then((message) => {
          console.log("Delete success:", message);
          this.fetchPaymentDueCollegelist();
          this.search = "";
        })
        .catch((error) => {
          console.error("Delete failed:", error);
        });
    },

    deleteSelectedColleges() {
      if (!this.selected.length) return;

      if (!confirm(`Delete ${this.selected.length} selected colleges?`)) {
        return;
      }

      const ids = this.selected.map((item) => item.id);

      console.log("Selected IDs:", ids);
      let blockParam = {
        exam_code: this.searchParam.exam_code,
        exam_year: this.searchParam.exam_year,
        ids: ids,
      };
      this.$store
        .dispatch("DeleteAllblockedColleges", blockParam)
        .then(() => {
          this.selected = [];
          this.fetchPaymentDueCollegelist();
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>
<style></style>
